// Vendors
import React from 'react';

// Hooks
import { useLanguageSelector } from '../../../hooks/useLanguageSelector';

// Components
import Logo from '../../../components/Logo/Logo';
import LanguageSelector from '../../../components/LanguageSelector/LanguageSelector';
import { Trans } from '../../../components/Trans';

// Styles
import './client-not-found.scss';

const ClientNotFound = () => {
  const { locale, isLanguageMenuOpen, languageWrapperRef, toggleLanguageMenu, handleLanguageSelect } = useLanguageSelector();

  return (
    <div className="client-not-found-page">
      <div className="client-not-found-header">
        <div className="client-not-found-logo-wrapper">
          <Logo className="client-not-found-logo" />
        </div>
        <LanguageSelector
          locale={locale}
          isLanguageMenuOpen={isLanguageMenuOpen}
          languageWrapperRef={languageWrapperRef}
          toggleLanguageMenu={toggleLanguageMenu}
          handleLanguageSelect={handleLanguageSelect}
        />
      </div>
      <div className="client-not-found-content">
        <h1 className="client-not-found-title">
          <Trans file="auth" id="clientNotFoundTitle" />
        </h1>
        <p className="client-not-found-message">
          <Trans file="auth" id="clientNotFoundMessage" />
        </p>
      </div>
    </div>
  );
};

export default ClientNotFound;
